import { useEffect, useState } from "react";
import { VITE_BACKEND_URL } from "@/api/config";

const OfflineBackendPage: React.FC = () => {
  const [reconnected] = useState(false);
useEffect(() => {
  // 🚨 NO uses safeFetch aquí
  // 🚨 NO uses endpoints globales

  const checkBackend = async () => {
    try {
      const res = await fetch(`${VITE_BACKEND_URL}/health`, {
        method: "GET",
        cache: "no-store",
      });

      if (res.ok) {
        window.location.href = "/";
      }
    } catch {
      // ignore
    }
  };

  const interval = setInterval(checkBackend, 5000);

  return () => clearInterval(interval);
}, []);

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center bg-gradient-to-b from-black via-zinc-900 to-black text-white relative overflow-hidden">

      {/* 🔵 Glow azul */}
      <div className="absolute inset-0 bg-blue-500/10 blur-3xl"></div>

      {/* 🟦 Card */}
      <div className="relative z-10 p-10 rounded-2xl bg-white/10 backdrop-blur-2xl border border-white/20 shadow-2xl flex flex-col items-center text-center max-w-md">

        {/* 🔵 Icono */}
        <div className="mb-6 animate-pulse">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-20 h-20 text-blue-400 drop-shadow-[0_0_15px_rgba(0,150,255,0.7)]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 12h18M12 3v18" />
          </svg>
        </div>

        {/* 📝 Texto */}
        <h1 className="text-3xl font-bold mb-3 text-blue-300 drop-shadow-[0_0_10px_rgba(0,150,255,0.6)]">
          Servidor no disponible
        </h1>

        <p className="text-zinc-300">
          Nuestro backend está temporalmente fuera de servicio.
        </p>
        <p className="text-zinc-400 mt-1">
          Estamos trabajando para solucionarlo.
        </p>

        {/* 🔄 Botón */}
        <button
          onClick={() => window.location.reload()}
          className="mt-6 px-6 py-2 rounded-xl bg-blue-600 hover:bg-blue-500 transition-all shadow-lg shadow-blue-900/40"
        >
          Reintentar
        </button>

        {/* 🟢 Reconexión */}
        {reconnected && (
          <p className="mt-4 text-green-400 animate-pulse">
            Conexión restaurada. Recargando…
          </p>
        )}
      </div>
    </div>
  );
};

export default OfflineBackendPage;